import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findpreFilter = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/preFilter/list?` + params,
        method: 'GET'
    })
}
export const findpreFilterWater = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/preFilter/list?` + params,
        method: 'GET'
    })
}
export const findpreEngineeringOrder= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/engineering_order?` + params,
        method: 'GET'
    })
}
// downloadExcelPureWaterGoods，下载服务清单
export const downloadExcelPureWaterGoods = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/preFilter/downloadExcelPureWaterGoods?` + params,
        method: 'GET',
        responseType: 'blob'
    })
}
// downloadReplacementReminderExcel，下载替换提醒
export const downloadReplacementReminderExcel = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/preFilter/downloadExcelReminder?day=` + params,
        method: 'GET',
        responseType: 'blob'
    })
}
// 查询工程服务清单详情
export const findpreEngineeringOrderDetail = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/engineering_order/${params.id}`,
        method: 'GET'
    })
}
// 查询服务清单详情
export const findpreFilterWaterDetail = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/preFilter/info?id=${params.id}&qrType=${params.qrType}`,
        method: 'GET'
    })
}
//查询服务清单评价详情
export const evaluateInfoView = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/dynamic_form/evaluateInfo/${params.id}?code=${params.code}`,
        method: 'GET'
    })
}
// 查询替换提醒详情
export const findpreFilterDownloadExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/preFilter/downloadExcel?` + params,
        method: 'GET'
    })
}
//通过审核
export const pass = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/preFilter/pass/${id}`,
        method: 'GET'
    })
}
//拒绝审核
export const refused = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/preFilter/refused`,
        method: 'POST',
        data: data
    })
    // return request({
    //     url: `${baseUrl}/joins-sales-cloud/v1/preFilter/refused/${id}`,
    //     method: 'GET'
    // })
}
//退回原因
export const refund = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/preFilter/refund`,
        method: 'POST',
        data: data
    })
}
//微信支付
export const serveOrderPay = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/preFilter/serveOrderPay/${id}`,
        method: 'GET'
    })
}
// 余额支付
export const balancePay = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/preFilter/balancePay/${id}`,
        method: 'GET'
    })
}